webpackJsonp([144251824217401],{

/***/ 243:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    flutter_redux: 'https://pub.dartlang.org/packages/flutter_redux',
	    dart_redux: '',
	    'Dart By Example': 'http://jpryan.me/dartbyexample/',
	    'Elixir School': 'https://elixirschool.com/en/'
	};

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n#mc_embed_signup_scroll {\n  display: grid;\n  grid-template-areas: "input submitButton";\n  grid-template-columns: 1fr 200px;\n  grid-gap: 20px;\n  background: ', ';\n  padding: 25px;\n  border-radius: 5px;\n  margin-bottom: 25px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2), 0 3px 1px -2px rgba(0, 0, 0, 0.12),\n  -2px 1px 5px 0 rgba(0, 0, 0, 0.12);\n  \n  .mc-field-group {\n    grid-area: input; \n    width: 100%;\n  }\n  .clear {\n    grid-area: submitButton;\n    width: 100%;\n  }\n  .input-text {\n    width: 100%;\n    background: white;\n    border: none;\n    border-radius: 5px;\n    font-size: 2rem;\n    padding: 15px 5px 15px;\n    transition: all .3s ease;\n    &::-webkit-input-placeholder {\n      color: #f6f6f6;\n    }\n    &:focus {\n      outline: none;\n      background: ', ';\n    }\n  }\n\n  .button {\n    width: 100%;\n    height: 56px;\n    text-align: center;\n    border: none;\n    border-radius: 5px;\n    background: #FF6666;\n    font-size: 2rem;\n    padding: 0 10px;\n    transition: 300ms all ease;\n    &:hover {\n      background: #ff4648;\n      cursor: pointer;\n    }\n  }\n}\n\n  .HideMe {\n    position: absolute;\n    left: -5000px;\n  }\n}\n\n'], ['\n#mc_embed_signup_scroll {\n  display: grid;\n  grid-template-areas: "input submitButton";\n  grid-template-columns: 1fr 200px;\n  grid-gap: 20px;\n  background: ', ';\n  padding: 25px;\n  border-radius: 5px;\n  margin-bottom: 25px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2), 0 3px 1px -2px rgba(0, 0, 0, 0.12),\n  -2px 1px 5px 0 rgba(0, 0, 0, 0.12);\n  \n  .mc-field-group {\n    grid-area: input; \n    width: 100%;\n  }\n  .clear {\n    grid-area: submitButton;\n    width: 100%;\n  }\n  .input-text {\n    width: 100%;\n    background: white;\n    border: none;\n    border-radius: 5px;\n    font-size: 2rem;\n    padding: 15px 5px 15px;\n    transition: all .3s ease;\n    &::-webkit-input-placeholder {\n      color: #f6f6f6;\n    }\n    &:focus {\n      outline: none;\n      background: ', ';\n    }\n  }\n\n  .button {\n    width: 100%;\n    height: 56px;\n    text-align: center;\n    border: none;\n    border-radius: 5px;\n    background: #FF6666;\n    font-size: 2rem;\n    padding: 0 10px;\n    transition: 300ms all ease;\n    &:hover {\n      background: #ff4648;\n      cursor: pointer;\n    }\n  }\n}\n\n  .HideMe {\n    position: absolute;\n    left: -5000px;\n  }\n}\n\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OptInForm = function (_Component) {
	  _inherits(OptInForm, _Component);
	
	  function OptInForm() {
	    _classCallCheck(this, OptInForm);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  OptInForm.prototype.render = function render() {
	    return _react2.default.createElement(
	      OptInContainer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { id: 'mc_embed_signup' },
	        _react2.default.createElement(
	          'form',
	          {
	            action: 'https://ericwindmill.us14.list-manage.com/subscribe/post?u=ba4877332e56c5f5d88603650&id=c03985072c',
	            method: 'post',
	            id: 'mc-embedded-subscribe-form',
	            name: 'mc-embedded-subscribe-form',
	            className: 'validate',
	            target: '_blank',
	            novalidate: true
	          },
	          _react2.default.createElement(
	            'div',
	            { id: 'mc_embed_signup_scroll' },
	            _react2.default.createElement(
	              'div',
	              { className: 'mc-field-group' },
	              _react2.default.createElement('input', {
	                type: 'email',
	                name: 'EMAIL',
	                placeholder: 'Your email address',
	                className: 'email input-text',
	                id: 'mce-EMAIL'
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'mce-responses', className: 'clear' },
	              _react2.default.createElement('div', { className: 'response', id: 'mce-error-response' }),
	              _react2.default.createElement('div', { className: 'response', id: 'mce-success-response' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'HideMe' },
	              _react2.default.createElement('input', {
	                type: 'text',
	                name: 'b_ba4877332e56c5f5d88603650_b1bfca0682',
	                tabindex: '-1',
	                value: ''
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'clear' },
	              _react2.default.createElement('input', {
	                type: 'submit',
	                value: 'Get Updates',
	                name: 'subscribe',
	                id: 'mc-embedded-subscribe',
	                className: 'button'
	              })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return OptInForm;
	}(_react.Component);
	
	var OptInContainer = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.greyBackgroundDarker;
	}, function (props) {
	  return props.theme.gatsbyLightest;
	});
	
	exports.default = OptInForm;
	module.exports = exports['default'];

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose([''], ['']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  overflow: scroll;\n  justify-self: center;\n  width: 100%;\n  padding: ', ';\n  @media screen and (max-width: 600px) {\n    order: 2;\n  }\n\n  max-width: ', ';\n  margin: auto;\n\n  a {\n    color: black;\n    background: ', ';\n    border-bottom: 2px solid ', ';\n    text-decoration: none;\n    transition: 500ms all ease;\n    padding: 0 5px;\n  }\n  a:hover {\n    border-bottom: 2px solid ', ';\n    background: ', ';\n  }\n\n  ul {\n    margin-left: 50px;\n  }\n  h3 {\n    color: ', ';\n  }\n'], ['\n  overflow: scroll;\n  justify-self: center;\n  width: 100%;\n  padding: ', ';\n  @media screen and (max-width: 600px) {\n    order: 2;\n  }\n\n  max-width: ', ';\n  margin: auto;\n\n  a {\n    color: black;\n    background: ', ';\n    border-bottom: 2px solid ', ';\n    text-decoration: none;\n    transition: 500ms all ease;\n    padding: 0 5px;\n  }\n  a:hover {\n    border-bottom: 2px solid ', ';\n    background: ', ';\n  }\n\n  ul {\n    margin-left: 50px;\n  }\n  h3 {\n    color: ', ';\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(32);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _SiteConfig = __webpack_require__(16);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _OptInForm = __webpack_require__(94);
	
	var _OptInForm2 = _interopRequireDefault(_OptInForm);
	
	var _thanks = __webpack_require__(243);
	
	var _thanks2 = _interopRequireDefault(_thanks);
	
	var _SiteHeader = __webpack_require__(69);
	
	var _SiteHeader2 = _interopRequireDefault(_SiteHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AboutPage = function (_Component) {
	  _inherits(AboutPage, _Component);
	
	  function AboutPage() {
	    _classCallCheck(this, AboutPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  AboutPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      AboutPageContainer,
	      null,
	      _react2.default.createElement(
	        BodyContainer,
	        null,
	        _react2.default.createElement(_SiteHeader2.default, null),
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Odds and Ends'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'These technologies and resources are used in this tutorial:'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          Object.keys(_thanks2.default).map(function (key) {
	            return _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: _thanks2.default[key] },
	                key
	              )
	            );
	          })
	        ),
	        _react2.default.createElement('div', { style: { height: '50px' } }),
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Get Updates'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Flutter by Example (and my helper resource: Dart for JavaScript Developers), are both being updated all the time. Get free updates to your inbox when more lessons are published on Flutter By Example or',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://dartforwebdevelopers.com' },
	            'Dart for Web Developers'
	          ),
	          '.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'NB: This will show up in your inbox as an email from ericwindmill.com.',
	            ' ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://ericwindmill.com/optin' },
	              'Get more information about what you\'re opting into.'
	            )
	          )
	        ),
	        _react2.default.createElement(_OptInForm2.default, null)
	      )
	    );
	  };
	
	  return AboutPage;
	}(_react.Component);
	
	exports.default = AboutPage;
	
	
	var AboutPageContainer = _styledComponents2.default.div(_templateObject);
	var BodyContainer = _styledComponents2.default.div(_templateObject2, function (props) {
	  return props.theme.sitePadding;
	}, function (props) {
	  return props.theme.contentWidthLaptop;
	}, function (props) {
	  return props.theme.linkBackground;
	}, function (props) {
	  return props.theme.brand;
	}, function (props) {
	  return props.theme.brand;
	}, function (props) {
	  return props.theme.brandLightest;
	}, function (props) {
	  return props.theme.redAccent;
	});
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-jsx-092aa9b00a62e6a3dc14.js